import React from "react";
import Signup from "../components/Signup";
import Login from "../components/Login";
import Welcome from "../components/Welcome";
import Profile from "../components/Profile";
import PasswordReset from "../components/PasswordReset";
import { motion } from "framer-motion";
import { pageTransition, pageSlide } from "../utils/styleUtils";

function UserScreen({ type }) {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageSlide}
      transition={pageTransition}
    >
      {type === "signup" && <Signup />}
      {type === "login" && <Login />}
      {type === "welcome" && <Welcome />}
      {type === "passwordReset" && <PasswordReset />}
      {type === "profile" && <Profile />}
    </motion.div>
  );
}
export default UserScreen;
